import { Calculator } from '@/modules/tax/models/calculators/Calculator';
import { CalculatorLineItem } from '@/modules/tax/models/calculators/CalculatorLineItem';
import { FinalTaxesRealEstateAsset } from '@/modules/tax/models/finaltaxescalculator/FinalTaxesRealEstateAsset';
import { FinalTaxesBankAccountAsset } from '@/modules/tax/models/finaltaxescalculator/FinalTaxesBankAccountAsset';
import { FinalTaxesOtherInvestmentAsset } from '@/modules/tax/models/finaltaxescalculator/FinalTaxesOtherInvestmentAsset';
import { FinalTaxesBusinessInterestAsset } from '@/modules/tax/models/finaltaxescalculator/FinalTaxesBusinessInterestAsset';
import { FinalTaxesArtValuableAsset } from '@/modules/tax/models/finaltaxescalculator/FinalTaxesArtValuableAsset';
import { FinalTaxesAssetType } from '@/modules/tax/enums/FinalTaxesAssetType';
import NumeralService from '@/modules/core/app/services/NumeralService';
import { ColumnFormat } from '@/modules/core/app/constants/data.constants';

export class FinalTaxesCalculator extends Calculator {
  lineItems: Relationship<CalculatorLineItem[]> | null;

  constructor(model: Partial<FinalTaxesCalculator> = {}) {
    super(model);

    this.lineItems = CalculatorLineItem.mapModelsOrNull(model.lineItems);

    this.calculations = {
      estimatedFinalTaxes: model.calculations?.estimatedFinalTaxes ?? 0,
      payableAtSpouseDeath: model.calculations?.payableAtSpouseDeath ?? 0
    };

    this.mapAssetModels(model.inputs.assets);
  }

  mapAssetModels(assets: Record<string, unknown>): void {
    this.inputs.assets = {
      [FinalTaxesAssetType.REAL_ESTATE.dataKey]: FinalTaxesRealEstateAsset.mapModels(
        assets[FinalTaxesAssetType.REAL_ESTATE.dataKey]
      ),
      [FinalTaxesAssetType.BANK_ACCOUNT.dataKey]: FinalTaxesBankAccountAsset.mapModels(
        assets[FinalTaxesAssetType.BANK_ACCOUNT.dataKey]
      ),
      [FinalTaxesAssetType.OTHER_INVESTMENT.dataKey]: FinalTaxesOtherInvestmentAsset.mapModels(
        assets[FinalTaxesAssetType.OTHER_INVESTMENT.dataKey]
      ),
      [FinalTaxesAssetType.BUSINESS_INTEREST.dataKey]: FinalTaxesBusinessInterestAsset.mapModels(
        assets[FinalTaxesAssetType.BUSINESS_INTEREST.dataKey]
      ),
      [FinalTaxesAssetType.ART_JEWELRY.dataKey]: FinalTaxesArtValuableAsset.mapModels(
        assets[FinalTaxesAssetType.ART_JEWELRY.dataKey]
      )
    };
  }

  get formattedEstimatedFinalTaxes(): string {
    return NumeralService.formatValue(
      this.calculations.estimatedFinalTaxes,
      ColumnFormat.FORMAT_CURRENCY,
      2
    );
  }

  get formattedPayableAtSpouseDeath(): string {
    return NumeralService.formatValue(
      this.calculations.payableAtSpouseDeath,
      ColumnFormat.FORMAT_CURRENCY,
      2
    );
  }
}
